import { type ReactNode } from 'react';

import IllustrationError from '@/components/IllustrationError';
import { PageLayoutCenter } from '@/components/PageLayout';

export const ErrorState = ({ errorMessage }: { errorMessage: ReactNode }) => {
  return (
    <PageLayoutCenter>
      <IllustrationError />
      {errorMessage}
    </PageLayoutCenter>
  );
};
